import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, Row, Select, Space, Tag } from 'antd'
import 'moment/locale/zh-cn'
import React, { ReactElement, useState } from 'react'
import { DateSelect } from '../../components/form/DateSelect'
import { SupervisorSelectModal } from '../../components/modal/SupervisorSelectModal'
import { DateTimeFormat } from '../../models/datetime'
import { getRiskName } from '../../models/rule'
import { ExceptionParams } from '../../services/exception'

export const ExceptionMessageQuerys = (props: {
  onValueChange: (queries: ExceptionParams) => void
}): ReactElement => {
  const [form] = Form.useForm()

  const [isVisible, setIsVisible] = useState(false)

  const [selectedSupervisors, setSelectedSupervisors] = useState<any[]>([])

  return (
    <>
      <Form
        form={form}
        onFinish={(values) => {
          const times = values.cautionTime
          const time = values.uploadEndTime
          props.onValueChange({
            ...values,
            cautionTime: undefined,
            cautionStartTime: times?.[0]?.format(DateTimeFormat),
            cautionEndTime: times?.[1]?.format(DateTimeFormat),
            uploadStartTime: time?.[0]?.format(DateTimeFormat),
            uploadEndTime: time?.[1]?.format(DateTimeFormat),
          } as any)
        }}
      >
        <Col>
          <Row style={{ width: '100%' }} align='middle' justify='space-between'>
            <Space>
              <Button type='primary' onClick={() => setIsVisible(true)}>
                选择卫健委(局)
              </Button>
              {/* <Form.Item name="status"  noStyle>
                <Select
                  showSearch
                  suffixIcon={<CaretDownFilled />}
                  style={{ width: 150 }}
                  allowClear
                  onChange={form.submit}
                  placeholder="处理状态"
                 
                >
                  <Select.Option value={1}>处理状态-未处理</Select.Option>
                  <Select.Option value={2}>处理状态-已处理</Select.Option>
                </Select>
              </Form.Item> */}
              {/* 预警时间筛选 */}
              <Form.Item name='cautionTime' noStyle>
                <DateSelect
                  placeholder='预警时间筛选'
                  style={{ width: 150 }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='uploadEndTime' noStyle>
                <DateSelect
                  placeholder='上传时间筛选'
                  style={{ width: 150 }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='level' noStyle>
                <Select
                  showSearch
                  suffixIcon={<CaretDownFilled />}
                  style={{ width: 150 }}
                  allowClear
                  onChange={form.submit}
                  placeholder='请选择风险等级'
                >
                  <Select.Option value={'HIGH_RISK'}>高风险</Select.Option>
                  {/* <Select.Option value={'LOT_HIGH_RISK'}>
                    较高风险
                  </Select.Option> */}
                  <Select.Option value={'MID_RISK'}>中风险</Select.Option>
                  <Select.Option value={'LOW_RISK'}>低风险</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name='osIds' noStyle>
                <Input type='hidden' />
              </Form.Item>
            </Space>
            <Space>
              <Form.Item name='dataCode' noStyle>
                <Input
                  autoComplete='off'
                  placeholder='请输入风险ID'
                  style={{ width: 200 }}
                  onChange={form.submit}
                  prefix={<SearchOutlined />}
                  allowClear
                />
              </Form.Item>
              <Form.Item name='ruleMainCode' noStyle>
                <Input
                  autoComplete='off'
                  placeholder='请输入预警规则'
                  style={{ width: 200 }}
                  onChange={form.submit}
                  prefix={<SearchOutlined />}
                  allowClear
                />
              </Form.Item>
              <Button
                type='primary'
                onClick={() => props.onValueChange(form.getFieldsValue())}
              >
                查询
              </Button>
            </Space>
          </Row>
          <Row style={{ marginTop: 10 }} align='middle'>
            {selectedSupervisors.map((s) => (
              <Tag
                key={s.osId}
                closable
                onClose={() => {
                  const selected = selectedSupervisors.filter(
                    (ss) => ss.osId !== s.osId
                  )
                  setSelectedSupervisors(selected)
                  form.setFieldsValue({
                    osIds:
                      selected.length === 0
                        ? undefined
                        : selected.map((s) => s.osId).join(','),
                  })
                  form.submit()
                }}
              >
                {s.osName}
              </Tag>
            ))}
          </Row>
        </Col>
      </Form>
      <SupervisorSelectModal
        initialValue={selectedSupervisors}
        visible={isVisible}
        onCancel={() => setIsVisible(false)}
        onOk={() => setIsVisible(false)}
        onChange={(s) => {
          const selected = s || []
          setSelectedSupervisors(selected)
          form.setFieldsValue({
            osIds:
              selected.length === 0
                ? undefined
                : selected.map((s) => s.osId).join(','),
          })
          form.submit()
        }}
      />
    </>
  )
}
